<template>
  <div class="fly_book" >
    <el-divider content-position="left">后台关联飞书文档</el-divider>
    <el-row class="mb-20 search-row" :gutter="20">
      <el-col :xs="24" :sm="8" :md="5" :lg="4">
        <div>
            <el-select
            v-model="searchArr.id"
            filterable
            remote
            reserve-keyword
            placeholder="请输入标题名称"
            size="mini"
            clearable
            :remote-method="searchRemoteCfcategory"
            :loading="Loading"
            @change="handleSearchCfcategory"
        >
            <el-option
            v-for="searchCompany in searchCategories"
            :key="searchCompany.id"
            :label="searchCompany.subheading"
            :value="searchCompany.id"
            >
            </el-option>
        </el-select>
        </div>
      </el-col>
    </el-row>
    <el-table
      ref="flyBookData"
      max-height="650"
      height="470"
      :data="flyBookData"
      style="width: 100%; margin-top: 10px"
      border
      size="mini"
      @cell-dblclick="tabClick"
      :row-class-name="tableRowClassName"
      :cell-class-name="tableCellClassName"
      :header-cell-style="{
        background: '#ecf4ff',
        color: '#333',
        fontWeight: '900',
        fontSize: '0.28rem',
      }"
       @row-click="device_detail"
    >
      <el-table-column prop="headline" label="栏目" width="200" align="left" fixed>
        <template slot-scope="scope">
          <span v-if="scope.row.index === clickRow && scope.column.index === clickCell">
            <el-input
              ref="editInput"
              v-model="scope.row.headline"
              maxlength="300"
              size="mini"
              @blur="inputBlur(scope.row)"
            />
          </span>
          <span v-else>{{ scope.row.headline }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="subheading" label="标题" width="200" align="left">
        <template slot-scope="scope">
          <span v-if="scope.row.index === clickRow && scope.column.index === clickCell">
            <el-input
              ref="editInput"
              v-model="scope.row.subheading"
              maxlength="300"
              size="mini"
              @blur="inputBlur(scope.row)"
            />
          </span>
          <span v-else>{{ scope.row.subheading }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="url" label="链接" width="550">
        <template slot-scope="scope">
          <span v-if="scope.row.index === clickRow && scope.column.index === clickCell">
            <el-input
              ref="editInput"
              v-model="scope.row.url"
              maxlength="300"
              size="mini"
              @blur="inputBlur(scope.row)"
            />
          </span>
          <span v-else>{{ scope.row.url }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="icon" label="图标" width="200">
        <template slot-scope="scope">
          <span v-if="scope.row.index === clickRow && scope.column.index === clickCell">
            <el-input
              ref="editInput"
              v-model="scope.row.icon"
              maxlength="300"
              size="mini"
              @blur="inputBlur(scope.row)"
            />
          </span>
          <span v-else>{{ scope.row.icon }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="is_show" label="是否显示">
        <template slot-scope="scope">
          是
          <el-switch
            v-model="ListIfDisplay[scope.row.id]"
            active-color="#ff4949"
            inactive-color="#13ce66"
            @click.native="editListRadioC(scope.row)"
          >
          </el-switch>
          否
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" width="300">
        <template slot-scope="scope">
          <el-input
            type="number"
            size="mini"
            v-model="listSort[scope.row.id]"
            @blur="setSortC(scope.row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="80">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="文档" placement="top">
            <el-button
              @click.native.prevent="flyingDocument(scope.row)"
              type="primary"
              size="mini"
              icon="el-icon-time"
              circle
            >
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-drawer
      :title="'飞书文档'"
      :visible.sync="RegistrarioneDrawer"
      direction="rtl"
      :before-close="handleCompanyInfoBeforeClose"
      size="60%"
    >
      <div style="margin-left: 0.4rem;margin-right: 0.4rem">
        <div class="m-tabs-content_amt">
          <div class="blocka">
            <el-button
            type="primary"
            size="mini"
            style="font-size: 0.28rem;margin-bottom: 0.2rem;"
                @click="readRecord"
            >新窗口打开
            </el-button>
            <el-tabs v-model="showTabPane" type="border-card">
              <el-tab-pane label="文档展示" name="first">
                <div ref="fsDrawer" id="fsDrawer"></div>
              </el-tab-pane>
              <el-tab-pane label="阅读记录" name="theSecond">
                <el-row class="count_style">
                    当前文档阅读总次数：{{ count ? count : 0 }}
                </el-row>
                <el-collapse
                  v-for="(records, index) in remarksLog"
                  :key="index"
                  accordion
                  v-model="activeName"
                  style="border-bottom: 1px solid #ebeef5"
                >
                  <el-collapse-item
                    :title="records.month + ' 操作记录详情'"
                    :name="index + 1"
                  >
                    <el-timeline>
                      <el-timeline-item
                        :timestamp="item.created_at"
                        v-for="(item, index) in records.record"
                        :key="index"
                        placement="top"
                      >
                        <el-card>
                          <p v-if="item.operation">{{ item.ope_name }} 在 {{ item.created_at }} 时 {{ item.operation }}</p>
                          <p v-if="!item.operation">无</p>
                        </el-card>
                      </el-timeline-item>
                    </el-timeline>
                  </el-collapse-item>
                </el-collapse>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: 'FlyingBook',
  data () {
    return {

      page: 1,
      sizePage: 10,
      Loading: false,
      RegistrarioneDrawer: false,
      url: null,
      editId: null,
      count: 0,
      showTabPane: 'first',
      flyBookData: [],
      remarksLog: [],
      searchFlyBook: [],
      activeName: 1,
      searchArr: {
        id: ''
      },
      searcher: null,
      listSort: [],
      clickRow: null,
      clickCell: null,
      getColumn: null,
      getColumnValue: null,
      itemUrl: null,
      searchCategories: [],
      ListIfDisplay: []
    }
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  mounted () {
    this.loadTable()
  },
  methods: {
    readRecord () {
      sessionStorage.removeItem('feiUrl')
      // let newPage = this.$router.resolve({
      //   path: '/documentation',
      //   query: { url: this.itemUrl }
      // })
      // window.open(newPage.href, '_blank')
      let newPage = this.$router.resolve({
        path: `/documentation`
      })
      sessionStorage.setItem('feiUrl', this.itemUrl)
      window.open(newPage.href, '_blank')
    },
    handleCompanyInfoBeforeClose (done) {
      this.$refs.fsDrawer.innerHTML = ''
      this.itemUrl = null
      done()
    },
    searchRemoteCfcategory (query) {
      if (query !== '') {
        this.Loading = true
        setTimeout(() => {
          this.Loading = false
          this.searchItem(query)
        }, 200)
      } else {
        this.searchCategories = []
      }
    },
    searchItem (query) {
      this.$axios
        .get('api/fly_book/flyname', {
          params: {
            search: query
          }
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.searchCategories = data.data.companies
          }
        })
        .catch()
    },
    handleSearchCfcategory (query) {
      this.searcher = query
      this.npage = 1
      setTimeout(() => {
        this.loadTable()
      })
    },
    loadTable () {
      this.$axios
        .post('api/fly_book/myfblist', {
          params: {
            page: this.page,
            sizePage: this.sizePage,
            searchItem: this.searcher
          }
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.flyBookData = data.data.pageData
            this.loadRadio()
            this.loadSort()
          }
        })
        .catch()
    },
    // 控制input显示 row 当前行 column 当前列
    tabClick (row, column, cell, event) {
      this.clickRow = row.index
      this.clickCell = column.index
      this.tabClickLabel = column.label
    },
    // 把每一行的索引放进row
    tableRowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },

    // 把每一列的索引放进column
    tableCellClassName ({ column, columnIndex }) {
      column.index = columnIndex
    },
    // 失去焦点初始化
    inputBlur (row) {
      console.log('失去焦点初始化', row)
      if (this.tabClickLabel === '栏目') {
        this.getColumn = 'headline'
        this.getColumnValue = row.headline
      }
      if (this.tabClickLabel === '标题') {
        this.getColumn = 'subheading'
        this.getColumnValue = row.subheading
      }
      if (this.tabClickLabel === '链接') {
        this.getColumn = 'url'
        this.getColumnValue = row.url
      }
      if (this.tabClickLabel === '图标') {
        this.getColumn = 'icon'
        this.getColumnValue = row.icon
      }
      this.$axios
        .get('api/fly_book/doubleedit', {
          params: {
            id: row.id,
            getColumn: this.getColumn,
            getColumnValue: this.getColumnValue
          }
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.clickRow = null
            this.clickCell = null
            this.tabClickLabel = ''
          } else {
            this.$message.error('操作失败')
          }
        })
        .catch()
    },
    loadRadio () {
      if (!this.categoryData) return false
      this.categoryData.map(item => {
        if (item.display === 1) {
          this.ListIfDisplay[item.id] = false
        } else {
          this.ListIfDisplay[item.id] = true
        }
      })
    },
    device_detail (val) {
      // this.needRow = val
      this.editId = val.id
    },
    editListRadioC (row) {
      setTimeout(() => {
        this.$axios
          .put('api/fly_book/listshow', {
            id: this.editId,
            display: this.ListIfDisplay[row.id] === false ? 1 : 2
          })
          .then(res => {
            const { data } = res
            if (data.code === 0) {
              this.$message.success(data.msg)
              this.loadTable()
            } else {
              this.$message.error(data.msg)
            }
          })
          .catch()
      })
    },
    setSortC (row) {
      setTimeout(() => {
        if (isNaN(this.listSort[row.id])) {
          this.$message.error('排序值为数字！')
          return false
        }
        this.$axios
          .put('api/fly_book/setsort', {
            id: this.editId,
            sort: this.listSort[row.id]
          })
          .then(res => {
            const { data } = res
            if (data.code === 1) {
              this.$message.success(data.msg)
              this.loadTable()
            } else {
              this.$message.error(data.msg)
            }
          })
          .catch()
      })
    },
    loadSort () {
      if (!this.flyBookData) return false
      this.flyBookData.map(item => {
        this.listSort[item.id] = Number(item.sort)
      })
    },
    flyingDocument (row) {
      this.itemUrl = row.url
      this.$axios
        .get('api/fly_book/getlog', {
          params: {
            id: row.id
          }
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.remarksLog = data.data.remarksLog
            this.count = data.data.count
            if (row.url) {
              this.sign(row.url)
            } else {
              this.$message.warning('没有填写文档地址!')
              return false
            }
            this.RegistrarioneDrawer = true
          } else {
            this.$message.error('操作失败')
          }
        }).catch()
    },
    sign (url) {
      this.$axios.get('/api/admin/fei_shu/documentation/auth?url=' + url)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.url = data.data.url
            this.signature(data.data.signature, data.data.timestamp, data.data.nonceStr, data.data.url)
          }
        })
    },
    signature (signature, timestamp, nonceStr, url) {
      window.webComponent.config({
        signature: signature,
        appId: 'cli_a2dafca2d3799013',
        timestamp: timestamp,
        nonceStr: nonceStr,
        url: url,
        jsApiList: ['DocsComponent'],
        lang: 'zh'
      }).then((res) => {
        let that = this
        that.myComponent = window.webComponent.render(
          'DocsComponent',
          {
            src: that.url,
            height: '800px',
            minHeight: '500px',
            width: '100%'
          },
          document.querySelector('#fsDrawer')
        )
        that.myComponent.config.setFeatureConfig({
          HEADER: {
            enable: false
          },
          LIKE: {
            enable: false
          },
          MORE_MENU: {
            enable: false
          },
          COMMENT: {
            partial: [
              false
            ]
          }
        })
      })
    }
  }
}
</script>

<style scoped>
.fly_book {
  /* margin-left: 3.6rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}
.count_style {
    padding: 2px 0 2px 0;
    font-size: 12px;
    color: #4C87FC;
}
.el-collapse {
border-bottom: 0;
border-top: 0;
}

.el-collapse >>> .el-collapse-item__header {
color: #4C87FC;
font-weight: bold;
}

.el-collapse >>> .el-collapse-item__arrow {
color: #4C87FC;
}
</style>



// WEBPACK FOOTER //
// src/pages/flying_book/FlyingBook.vue